"use server";

import { revalidatePath } from "next/cache";
import { getSession } from "@/lib/auth/cookies";
import { withTenant } from "@/lib/auth/with-tenant";
import { prisma } from "@/lib/db";
import {
  createChatSchedule,
  deleteChatSchedule,
  updateChatSchedule,
} from "@/lib/chat/schedule";
import { readDisplayTimeZone } from "@/lib/ui/timezone-cookie";

async function scheduleTimeZone(tenantId: string): Promise<string> {
  const tenant = await prisma.tenant.findUnique({
    where: { id: tenantId },
    select: { timeZone: true },
  });
  return readDisplayTimeZone(tenant?.timeZone);
}

export async function createChatScheduleAction(formData: FormData) {
  const session = await getSession();
  if (!session) {
    return;
  }
  await withTenant(async () => {
    const timeZone = await scheduleTimeZone(session.tenantId);
    await createChatSchedule({
      userId: session.userId,
      question: String(formData.get("question") ?? ""),
      timeLocal: String(formData.get("timeLocal") ?? ""),
      timeZone,
    });
  });
  revalidatePath("/");
}

export async function updateChatScheduleAction(formData: FormData) {
  const session = await getSession();
  if (!session) {
    return;
  }
  const id = String(formData.get("id") ?? "");
  await withTenant(async () => {
    const timeZone = await scheduleTimeZone(session.tenantId);
    await updateChatSchedule({
      userId: session.userId,
      id,
      question: String(formData.get("question") ?? ""),
      timeLocal: String(formData.get("timeLocal") ?? ""),
      timeZone,
    });
  });
  revalidatePath("/");
}

export async function toggleChatScheduleAction(formData: FormData) {
  const session = await getSession();
  if (!session) {
    return;
  }
  const id = String(formData.get("id") ?? "");
  const enabled = String(formData.get("enabled") ?? "") === "true";
  await withTenant(async () => {
    const timeZone = await scheduleTimeZone(session.tenantId);
    await updateChatSchedule({
      userId: session.userId,
      id,
      enabled,
      timeZone,
    });
  });
  revalidatePath("/");
}

export async function deleteChatScheduleAction(formData: FormData) {
  const session = await getSession();
  if (!session) {
    return;
  }
  const id = String(formData.get("id") ?? "");
  await withTenant(() =>
    deleteChatSchedule({ userId: session.userId, id }),
  );
  revalidatePath("/");
}
